import "./Services.css";
import { BsSearch, BsPersonBadge, BsChatDots, BsShieldX, BsJournalCheck } from "react-icons/bs";
import { forwardRef } from "react";
import ServiceCard from "../ServiceCard/ServiceCard";

const Services = forwardRef((_, ref) => {

  const cardsData = [
    {
      icon: <BsSearch size={40} className="text-success me-4" />,
      title: "Análisis gratuito",
      text: "Analizamos de manera gratuita tu caso.",
    },
    {
      icon: <BsPersonBadge size={40} className="text-success me-4" />,
      title: "Identificación de deuda",
      text: "Identificamos quién tiene tu deuda.",
    },
    {
      icon: <BsChatDots size={50} className="text-success me-4" />,
      title: "Negociación directa",
      text: "Negociamos con bancos, tarjetas de crédito o financieras.",
    },
    {
      icon: <BsShieldX size={40} className="text-success me-4" />,
      title: "Freno a abusos",
      text: "Frenamos intereses abusivos y cobranzas agresivas.",
    },
    {
      icon: <BsJournalCheck size={40} className="text-success me-4" />,
      title: "Plan legal a medida",
      text: "Diseñamos un plan legal personalizado para ayudarte a salir adelante.",
    },
  ];

  return (
    <div ref={ref} className="container" id={1}>
      <div
        className="service-heading"
        data-aos="zoom-out-down"
        data-aos-once="true"
      >
        <span className="title-section">¿Qué podemos hacer por vos?</span>
      </div>
      <div className="row justify-content-center g-4">
        {cardsData.slice(0, 3).map((card, index) => (
          <div className="col-12 col-md-4" key={index}>
            <ServiceCard icon={card.icon} title={card.title} text={card.text} />
          </div>
        ))}
      </div>

      <div className="row justify-content-center mt-4 g-4">
        {cardsData.slice(3).map((card, index) => (
          <div className="col-12 col-md-4" key={index + 3}>
            <ServiceCard icon={card.icon} title={card.title} text={card.text} />
          </div>
        ))}
      </div>
    </div>
  );
});

export default Services;